import {parse} from 'date-fns';
import {format} from 'date-fns-tz';

export const formatYearMonth = (yearMonth: string) => {
  const date = parse(yearMonth as string, 'yyyyMM', new Date());
  return format(date, 'MMMM, yyyy');
};
